export default __webpack_public_path__ + "static/media/what-we-offers-03.8b6eb7f0.jpg";